define('views/auth/login-form',['require','mediator','jquery','views/base/form','helpers/application','text!templates/auth/login-form.ejs'],function(require) {
    'use strict';

    var mediator = require('mediator'),
        $ = require('jquery'),
        FormView = require('views/base/form'),
        applicationHelper = require('helpers/application'),
        template = require('text!templates/auth/login-form.ejs');

    var LoginFormView = FormView.extend({
        template: template,
        className: 'login-form modal-backdrop dark in',
        customValidation: true,

        initialize: function() {
            FormView.prototype.initialize.apply(this, arguments);
            this.delegate('click', '#btn-demo-enter', this.clickDemoEnter);
            this.delegate('click', '#registration', this.gotoRegistration);
            this.delegate('click', '#restoration', this.gotoRestoration);

        },

        gotoRegistration: function() {
            applicationHelper.redirectTo('auth#registrationInput', this.model.toJSON(), { forceStartup: true });
        },

        gotoRestoration: function() {
            applicationHelper.redirectTo('auth#restorationInput', this.model.toJSON(), { forceStartup: true });
        },

        save: function() {
            this.signin();
        },

        clickDemoEnter: function() {
            this.model.setDemo();
            this.signin();
        },

        signin: function() {
            var _this = this;

            this.model
                .save()
                .done(function(response) {
                    if (response.accessToken) {
                        _this.dismiss();

                        mediator
                            .signin(response.accessToken)
                            .done(function() {
                                applicationHelper.redirectTo('dashboard#show', {}, { forceStartup: true });
                            });

                    } else {
                        _this.render();
                    }
                })
                .fail(function() {
                    _this.errorMessages = ['Неправильный номер телефона или пароль'];
                    _this.render();
                });
        },

        render: function() {
            FormView.prototype.render.apply(this, arguments);
            $('html').addClass('modal-visible');
        },

        dispose: function() {
            if (this.disposed) { return; }

            $('html').removeClass('modal-visible');

            FormView.prototype.dispose.apply(this, arguments);
        }
    });

    return LoginFormView;
});

